import { render } from "./DetalleObra.vue?vue&type=template&id=0d37aabe&scoped=true"
import script from "./DetalleObra.vue?vue&type=script&lang=js"
export * from "./DetalleObra.vue?vue&type=script&lang=js"

import "./DetalleObra.vue?vue&type=style&index=0&id=0d37aabe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d37aabe"

export default script